import React from 'react';
import { FileTextIcon, GiftIcon, LayoutGridIcon, BriefcaseIcon, MessageSquareIcon, ZapIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { bonuses } from '../../data/content';
const icons = [ZapIcon, FileTextIcon, MessageSquareIcon, BriefcaseIcon, LayoutGridIcon];
export function BonusesSection() {
  return <section id="bonuses" className="bg-brand-mist px-5 py-14 sm:py-20" data-id="element-24" data-mp="1bihlafabqttz">
      <div className="mx-auto max-w-5xl" data-id="element-25" data-mp="wma0bcr3dodn">
        <GiftIcon className="mx-auto h-10 w-10 text-brand-violet" aria-hidden="true" data-id="element-26" data-mp="wpeaqrv5hgcr" />
        <div className="mt-4" data-id="element-27" data-mp="11k1qa186f0f7">
          <SectionHeading title="And You're Getting 5 Professional Toolkits Too." data-id="element-28" data-mp="nmmyipugagk2" />
        </div>

        <ul className="mt-10 grid gap-4 md:grid-cols-2" role="list" data-id="element-29" data-mp="sl6jamxb5mau">
          {bonuses.map((bonus, index) => {
          const Icon = icons[index];
          return <li key={bonus.title} className={`flex gap-4 rounded-2xl border-l-4 border-brand-violet bg-white p-5 shadow-sm sm:p-6 ${index === bonuses.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-30" data-mp="2hyjt2ro6w2jc" data-mpi={index}>
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-xl bg-brand-violet/10 text-brand-violet" data-id="element-31" data-mp="1g71up0gz6axz">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-32" data-mp="1tx57l0tyssar" />
                </span>
                <div data-id="element-33" data-mp="1ozvbx3fzfkeh">
                  <p className="text-xs font-black uppercase tracking-[0.14em] text-brand-violet" data-id="element-34" data-mp="1p0n9gjt53s7e">Bonus #{index + 1}</p>
                  <h3 className="mt-1.5 font-display text-xl font-bold leading-snug text-brand-ink" data-id="element-35" data-mp="x7e4webirytv">{bonus.title}</h3>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-brand-ink/70" data-id="element-36" data-mp="1b7owjjknlhg3">{bonus.description}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mt-12 text-center" data-id="element-37" data-mp="2mmc7a355nnxl">
          <p className="text-sm font-black uppercase tracking-[0.14em] text-brand-violet sm:text-base" data-id="element-38" data-mp="2ml13w4fmgi70">
            6 Complete Systems + 5 Premium Bonuses
          </p>
          <p className="mt-2 font-display text-3xl font-bold text-brand-ink sm:text-4xl" data-id="element-39" data-mp="2pogoi5iu7i1c">All included in one system.</p>
        </div>
      </div>
    </section>;
}